(function () {
  'use strict';

  const { iman, BaseCarousel, Lookbook, GalleryCard, ModalProduct } = window.Universe;

  class TouchAndTake {
    constructor() {
      this.sections = [];
      this.init();
    }

    setup(sectionDOM) {
      if (sectionDOM.lookbook && sectionDOM.carousel) {
        sectionDOM.handleLookbookChange = (event) => {
          const index = event.detail.index;
          if (sectionDOM.carousel.instance.selectedScrollSnap() === index) return;
          sectionDOM.carousel.instance.scrollTo(index);
        };

        sectionDOM.handleCarouselChange = () => {
          const index = sectionDOM.carousel.instance.selectedScrollSnap();
          sectionDOM.lookbook.select(index);
          this.updateLiveRegion(sectionDOM);
        };

        sectionDOM.lookbook.DOM.container.addEventListener('lookbook:change', sectionDOM.handleLookbookChange);
        sectionDOM.carousel.instance.on('select', sectionDOM.handleCarouselChange);

        this.setupCards(sectionDOM);
        this.setupAccessibility(sectionDOM);
      }
    }

    setupAccessibility(sectionDOM) {
      this.setupKeyboardNavigation(sectionDOM);
      this.setupLiveRegion(sectionDOM);
      this.handleReducedMotion(sectionDOM);
    }

    setupKeyboardNavigation(sectionDOM) {
      sectionDOM.onKeyDown = (e) => {
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
          return;
        }

        switch (e.key) {
          case 'ArrowRight':
            e.preventDefault();
            sectionDOM.carousel.instance.scrollNext();
            break;
          case 'ArrowLeft':
            e.preventDefault();
            sectionDOM.carousel.instance.scrollPrev();
            break;
          case 'Home':
            e.preventDefault();
            sectionDOM.carousel.instance.scrollTo(0);
            break;
          case 'End':
            e.preventDefault();
            const totalSlides = sectionDOM.carousel.instance.scrollSnapList().length;
            sectionDOM.carousel.instance.scrollTo(totalSlides - 1);
            break;
          default:
            break;
        }
      };

      sectionDOM.viewport = sectionDOM.carousel.DOM.carousel;
      if (sectionDOM.viewport) {
        sectionDOM.viewport.addEventListener('keydown', sectionDOM.onKeyDown);
      }
    }

    setupLiveRegion(sectionDOM) {
      const section = sectionDOM.carousel.DOM.wrap.closest('.js-touch-and-take');
      if (!section) return;

      let liveRegion = section.querySelector('.js-carousel-live-region');

      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.className = 'js-carousel-live-region sr-only';
        liveRegion.setAttribute('role', 'status');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');

        const carouselWrap = section.querySelector('.js-carousel-wrap');
        if (carouselWrap) {
          carouselWrap.insertBefore(liveRegion, carouselWrap.firstChild);
        }
      }

      sectionDOM.liveRegion = liveRegion;
      this.updateLiveRegion(sectionDOM);
    }

    updateLiveRegion(sectionDOM) {
      if (sectionDOM.liveRegion && sectionDOM.carousel) {
        const currentSlide = sectionDOM.carousel.instance.selectedScrollSnap() + 1;
        const totalSlides = sectionDOM.carousel.instance.scrollSnapList().length;
        const template = window.touchAndTakeStrings?.slideAnnouncement || 'Slide [current] of [total]';
        sectionDOM.liveRegion.textContent = template.replace('[current]', currentSlide).replace('[total]', totalSlides);
      }
    }

    handleReducedMotion(sectionDOM) {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        if (sectionDOM.carousel && sectionDOM.carousel.autoplay) {
          sectionDOM.carousel.autoplay.stop();
        }
      }
    }

    setupCards(sectionDOM) {
      sectionDOM.cards = sectionDOM.carousel.DOM.carousel.querySelectorAll('.js-gallery-card');
      sectionDOM.quickAdd = document.querySelector('.js-quick-add-container');

      if (sectionDOM.cards) {
        sectionDOM.cardInstances = [];
        sectionDOM.quickAddInstances = [];

        sectionDOM.cards.forEach((card) => {
          const cardInstance = new GalleryCard(card);
          sectionDOM.cardInstances.push(cardInstance);

          if (sectionDOM.quickAdd) {
            const cardQuickAdd = new ModalProduct(card, sectionDOM.quickAdd);
            sectionDOM.quickAddInstances.push(cardQuickAdd);
          }
        });
      }
    }

    destroyCards(sectionDOM) {
      if (sectionDOM.cardInstances) {
        sectionDOM.cardInstances.forEach((card) => {
          card.destroy();
        });
      }

      if (sectionDOM.quickAddInstances) {
        sectionDOM.quickAddInstances.forEach((quickAdd) => {
          quickAdd.destroy();
        });
      }

      sectionDOM.cardInstances = undefined;
      sectionDOM.quickAddInstances = undefined;
      sectionDOM.cards = undefined;
      sectionDOM.quickAdd = undefined;
    }

    reinit() {
      this.destroy();
      this.init();
    }

    destroy() {
      this.sections.forEach((sectionDOM) => {
        if (sectionDOM.lookbook) {
          sectionDOM.lookbook.DOM.container.removeEventListener('lookbook:change', sectionDOM.handleLookbookChange);
          sectionDOM.lookbook.destroy();
        }
        if (sectionDOM.carousel) {
          if (sectionDOM.carousel.instance) {
            sectionDOM.carousel.instance.off('select', sectionDOM.handleCarouselChange);
          }
          sectionDOM.carousel.destroy();
        }
        if (sectionDOM.viewport && sectionDOM.onKeyDown) {
          sectionDOM.viewport.removeEventListener('keydown', sectionDOM.onKeyDown);
        }
        this.destroyCards(sectionDOM);
      });
      this.sections = [];
    }

    init(container = document) {
      const sections = container.querySelectorAll('.js-touch-and-take');

      if (sections.length) {
        sections.forEach((section) => {
          const lookbookContainer = section.querySelector('.js-lookbook');
          const carouselWrap = section.querySelector('.js-carousel-wrap');
          const carousel = section.querySelector('.js-carousel');

          if (lookbookContainer && carouselWrap && carousel) {
            const sectionDOM = {
              lookbook: new Lookbook(lookbookContainer),
              carousel: new BaseCarousel({
                wrap: carouselWrap,
                carousel: carousel,
                carouselOptions: {
                  align: 'center',
                  containScroll: 'trimSnaps',
                  loop: true,
                  container: carousel,
                  dragFree: false,
                  slidesToScroll: 1,
                },
                onReady: () => {
                  this.setup(sectionDOM);
                },
              }),
            };
            this.sections.push(sectionDOM);
          }
        });
      }
    }
  }

  function init() {
    if (!iman.get('touchAndTake')) {
      iman.add('touchAndTake', new TouchAndTake());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.TouchAndTake = TouchAndTake;
})();
